import React from 'react'
import CategoryList from '../components/products/CategoryList'

function CategoriesPage() {
  return <CategoryList />
}

export default CategoriesPage
